import { Calculator, TrendingDown, MonitorSmartphone, Route } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const AREAS = [
  { icon: Calculator, title: "Your Current Costs", copy: "A clear breakdown of what you're paying today and your true effective rate." },
  { icon: TrendingDown, title: "Potential Savings", copy: "Where there may be opportunities to reduce your processing costs." },
  { icon: MonitorSmartphone, title: "Equipment & Integrations", copy: "What's required on the equipment and software side — and what you can keep." },
  { icon: Route, title: "What Switching Involves", copy: "Exactly what a transition would look like for your business, step by step." },
];

export const ReviewCovers = () => (
  <section id="review-covers" data-testid="review-covers" className="border-y border-white/10 bg-surface/40 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-6">
      <SectionTag index="02" label="Your Free Review" />
      <Reveal className="mt-6 max-w-3xl">
        <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl">
          Know What You're Paying — <span className="text-mint">and What Could Change.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {AREAS.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.07}>
            <div data-testid={`review-area-${i}`} className="group h-full rounded-3xl border border-ink/10 bg-void/60 p-8 transition-colors duration-500 hover:border-mint/50">
              <a.icon size={24} className="text-mint transition-transform duration-500 group-hover:scale-110" />
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight">{a.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55">{a.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mx-auto mt-12 max-w-3xl text-center">
        <p className="text-sm leading-relaxed text-white/50">
          Actual pricing and potential savings depend on your business, transaction mix, services,
          and current processing arrangement. Your review will help you understand the options.
        </p>
      </Reveal>
    </div>
  </section>
);
